import './ResetModal.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Error from '../../../../common/Error/Error';
import LoadingSpinner from '../../../../common/LoadingSpinner/LoadingSpinner';
import GoodsOut from '../../../../api/controllers/GoodsOut/GoodsOut';
import GoodsIn from '../../../../api/controllers/GoodsIn/GoodsIn';

// General ResetModal Component
const ResetModal = ({
  category,
  movement,
  setModalOpen,
  refreshPackages,
  packages,
  movementType,
  assignment,
}) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();

  const resetLoad = () => {
    setLoading(true);
    GoodsOut.remove(
      category,
      movement.id,
      packages.map(pkg => pkg?.id),
    )
      .then(() => {
        setLoading(false);
        refreshPackages();
        setModalOpen(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const resetUnload = () => {
    setLoading(true);
    GoodsIn.updatePackageCount(category, movement.id, assignment?.job?.id, 0)
      .then(() => {
        setLoading(false);
        refreshPackages();
        setModalOpen(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  return (
    <div className="reset_movement_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <div className="message">
        {movementType == 'imports' || movementType == 'collections'
          ? 'Remove all packages that are already unloaded?'
          : 'Remove all packages that are already loaded?'}
      </div>
      <div className="reset_movement_buttons">
        <button className="reset_button" onClick={() => setModalOpen(false)}>
          Cancel
        </button>
        <button
          className="ok_button"
          onClick={
            movementType == 'imports' || movementType == 'collections'
              ? () => resetUnload()
              : () => resetLoad()
          }
        >
          OK
        </button>
      </div>
    </div>
  );
};

ResetModal.propTypes = {
  category: PropTypes.string,
  movementType: PropTypes.string,
  movement: PropTypes.object,
  assignment: PropTypes.object,
  setModalOpen: PropTypes.func,
  refreshPackages: PropTypes.func,
  packages: PropTypes.array,
};

export default ResetModal;
